import { Lottie } from '@alfonmga/react-lottie-light-ts';
import { css } from '@emotion/css';
import React, { useEffect } from 'react';
import { usePrefersReducedMotion } from 'src/components/shared/usePrefersReducedMotion';

function animPath(pointFactor: number) {
  switch (pointFactor) {
    case 3:
      return '/anim/fortune/nookpoint-3x.json';
    case 2:
      return '/anim/fortune/nookpoint-2x.json';
    default:
      return '/anim/fortune/nookpoint-1x.json';
  }
}

interface FortuneAnimationProps {
  pointFactor: number;
  onComplete: () => void;
}

export const FortuneAnimation: React.FC<FortuneAnimationProps> = ({ pointFactor, onComplete }) => {
  const prefersReducedMotion = usePrefersReducedMotion();
  useEffect(() => {
    if (prefersReducedMotion) {
      onComplete();
    }
  }, [onComplete, prefersReducedMotion]);

  return prefersReducedMotion ? null : (
    <div
      className={css`
        width: 100%;
        max-width: 480px;
        height: 200px;
        margin: 12px auto 0;
        @media (min-width: 330px) {
          height: 280px;
        }
      `}
    >
      <Lottie
        config={{
          path: animPath(pointFactor),
          rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
            progressiveLoad: true
          }
        }}
        lottieEventListeners={[
          {
            name: 'complete',
            callback: onComplete
          },
          {
            name: 'error',
            callback: onComplete // 読み込みエラーの場合は完了callbackを呼ぶ
          }
        ]}
      />
    </div>
  );
};
